/**
 * @author      matthew@zumper.com (Matthew Talamini)
 * @copyright   Copyright (c) 2021, Zumper
 * @description shortTermAvailability reducer smushing
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { default as rootReducer } from './reducers/index'

// eslint-disable-next-line import/no-default-export
export default filterActions(rootReducer, Object.values(constants))
